import React, {useState} from 'react';
import {Link, useParams} from "react-router-dom";
import DisplayMetaWithImport from "../components/DisplayMetaWithImport.comp";
import {formatDate} from "../../../utils/utils";

import {
    v3Level5Competency
} from "../../../services/metadata.service";


const columns = [
    {name: 'Code', key: 1, json_key: 'code', data_key: 'code'},
    {name: 'Name', key: 2, json_key: 'full_name', data_key: 'full_name'},
    {name: 'Definition', key: 3, json_key: 'definition', data_key: 'definition'},
    {name: 'Category6', key: 10, json_key: 'category6', data_key: 'category6'},
    {name: 'DQC#', key: 0, json_key: 'dqc_no', data_key: 'dqc_no'},
    {name: 'DQM#', key: 11, json_key: 'dqm_no', data_key: 'dqm_no'},
    {name: 'Stakeholder#', key: 12, json_key: 'stakeholder_no', data_key: 'stakeholder_no'},
    {name: 'DQA#', key: 13, json_key: 'dqa_no', data_key: 'dqa_no'},
]


const
    tableCols = [
        {
            label: 'Code',
            field: 'code', width: 150
        },
        {
            label: 'Full Name',
            field: 'full_name', width: 150
        },
        {
            label: 'Definition',
            field: 'definition', sort: 'disabled', width: 150
        },
        {
            label: 'Category6',
            field: 'category6', sort: 'disabled', width: 150
        },
        {
            label: 'DQC#',
            field: 'dqc_no', sort: 'disabled', width: 150
        },
        {
            label: 'Created',
            field: 'createdAt', width: 150
        },
        {
            label: 'Updated',
            field: 'updatedAt', width: 150
        },
        {
            label: 'Actions',
            field: 'actions', sort: 'disabled', searchable: false
        }
    ]


export default function Level5CompetencyPage() {

    const { url_param_str } = useParams();
    const search_query = url_param_str.split('=').length > 1 ? url_param_str.split('=')[1]  : '';

    const table_row__additional_rendering = (row) => {
        const create_data = formatDate(row.createdAt) + ',\n ' + (row.createdBy ? row.createdBy : '');
        row.createdAt = create_data;

        const update_data = formatDate(row.updatedAt) + ',\n ' + (row.updatedBy ? row.updatedBy : '');
        row.updatedAt = update_data;

        return row;
    }

    return (
        <DisplayMetaWithImport
            title={'Level5 Competency'}
            modal_title={'Level5 Competency - Data Preview'}
            sheet_name={'Level5 (Competency)'}
            columns={columns}
            tableCols={tableCols}
            tableSpRender={table_row__additional_rendering}
            search_query={search_query}
            listAPI={v3Level5Competency.listData}
            postAPI={v3Level5Competency.postData}
            deleteAPI={v3Level5Competency.deleteEntity}
            updateAPI={v3Level5Competency.updateEntity}
            preRemoveAPI={v3Level5Competency.preRemoveCheck}
        />
    );
}
